import { Panel } from "primereact/panel";
import { Tag } from "primereact/tag";
import { formatDateTime } from "@/lib/utils";
import type { AdminEvent } from "../types";

export function EventInformationPanel(props: { event: AdminEvent }) {
  const { event } = props;
  return (
    <Panel header="Event Information">
      <div className="flex flex-column gap-3">
        <div className="flex align-items-center gap-2">
          <span className="font-semibold">Status:</span>
          <Tag
            value={
              event.isCancelled
                ? "Cancelled"
                : event.isPublished
                  ? "Published"
                  : "Draft"
            }
            severity={
              event.isCancelled ? "danger" : event.isPublished ? "success" : "warning"
            }
          />
        </div>
        {event.isBookable && <div className="flex align-items-center gap-2">
          <span className="font-semibold">Featured:</span>
          <Tag
            value={event.isFeatured ? "Yes" : "No"}
            severity={event.isFeatured ? "success" : "info"}
          />
        </div>}
        <div>
          <span className="font-semibold">Location:</span>
          <span className="ml-2">{event.location || "Sailing Club"}</span>
        </div>
        <div>
          <span className="font-semibold">Dates: </span>
          <span>
            {event.startsAt ? formatDateTime(event.startsAt, event.timezone) : "-"} -{" "}
            {event.endsAt ? formatDateTime(event.endsAt, event.timezone) : "-"}
          </span>
        </div>
        <div>
          <span className="font-semibold">Description:</span>
          <p className="mt-1 mb-0">{event.description || "-"}</p>
        </div>
        {event.isBookable && (
          <>
            <div>
              <span className="font-semibold">Audience:</span>
              <span className="ml-2">{event.audience || "-"}</span>
            </div>
            <div>
              <span className="font-semibold">Schedule:</span>
              {event.schedule ? (
                <div className="mt-1 flex flex-column gap-1">
                  {event.schedule.split("\n").map((line, idx) => (
                    <div key={idx} className="flex align-items-start gap-2">
                      <span>•</span>
                      <span>{line}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <span className="ml-2">-</span>
              )}
            </div>
            <div>
              <span className="font-semibold">What to Bring:</span>
              <span className="ml-2">{event.whatToBring || "-"}</span>
            </div>
            <div>
              <span className="font-semibold">Consent Requirements:</span>
              <div className="mt-1 flex flex-wrap gap-3">
                <span className="flex align-items-center gap-2">
                  <i
                    className={`pi ${
                      event.requiresConsentForm
                        ? "pi-check-circle text-green-500"
                        : "pi-times-circle text-red-500"
                    }`}
                  />
                  <span>Consent form</span>
                </span>
                <span className="flex align-items-center gap-2">
                  <i
                    className={`pi ${
                      event.requiresPhotoConsent
                        ? "pi-check-circle text-green-500"
                        : "pi-times-circle text-red-500"
                    }`}
                  />
                  <span>Photo consent</span>
                </span>
                <span className="flex align-items-center gap-2">
                  <i
                    className={`pi ${
                      event.groupsEnabled
                        ? "pi-check-circle text-green-500"
                        : "pi-times-circle text-red-500"
                    }`}
                  />
                  <span>Participant groups</span>
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </Panel>
  );
}








